import { render, staticRenderFns } from "./PNApptTime.vue?vue&type=template&id=096c9458"
import script from "./PNApptTime.vue?vue&type=script&lang=js"
export * from "./PNApptTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports